import { SELECIONAR_POLTRONAS } from '../../actions/types';

const initialState = undefined

export default function reducerPoltronasSelecionadas (state = [], action = initialState) {
  switch (action.type) {
    case SELECIONAR_POLTRONAS: {
      return action.payload
    }

    default:
      return state
  }
}
